import React, { useRef, useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { FaDownload } from "react-icons/fa";
import PeopleTable from "./peopleTable";
import { postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { useAppDispatch } from "../../store/storeRequests";

const People: React.FunctionComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [excelFile, setExcelFile] = useState<any>(null);
  const dispatch = useAppDispatch()
  const [isPeopleDataFetched, setIsPeopleDataFetched] = useState(false);

  const redirect = () => {
    navigate("/people/add");
  };

  const handleShowModal = () => {
    setExcelFile(null)
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleDownload = () => {
    const filePath = '/files/Import_People_Sample.xlsx'
    
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'Import_People_Sample.xlsx'; 
    document.body.appendChild(link);
    link.click();
    
    document.body.removeChild(link);
  }

  const handleFileChange = (ev: any)=>{
    const excelFile = ev.target.files[0]
    
    if(excelFile && excelFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
      dispatch(showToast("Please upload an excel file with .xlsx extension"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return
   }

    setExcelFile(excelFile)
}

  const handleFileUpload = async (ev: any)=>{
    // console.log("The execel file",excelFile)
    ev.preventDefault()
    if(!excelFile){
       dispatch(showToast("Please upload excel file"));
       setTimeout(() => dispatch(hideToast()), 3000);
       return
    }

    const formData = new FormData();
    formData.append('excelFile', excelFile)
    try {
      const response = await postMultipartDetails(APIList.IMPORT_PEOPLE, formData)
      // console.log("Handle upload response:",response)
      console.log(response)

      if(response.status === "Failed"){
        dispatch(showToast("Invalid Excel."));
        setTimeout(() => dispatch(hideToast()), 3000);
        return
      }

     else if(response.statusCode === 200){
      const { totalRecord, insertedCount, updatedCount, invalidDetails } = response.data;

      let message = "";
    
      if (totalRecord === 0) {
        message = "Invalid Excel.";
      } 
      else if (insertedCount > 0 || updatedCount > 0) {
        message = `Import successful. ${insertedCount} record(s) added, ${updatedCount} record(s) updated.`;
      } 
      // Check for invalid records
      if (invalidDetails.length > 0) {
        message += `\n${invalidDetails.length} invalid record(s) found:`;
        invalidDetails.forEach((detail:string, index:number) => {
          message += `\n${detail}`; 
        });
      }
    
      if (message) {
        dispatch(showToast(message)); 
        setTimeout(() => dispatch(hideToast()), 10000);
      }

      }
      else{
        // const errorMessage = response.data.invalidDetails.reduce((acc:string, error:string, index:number) => {
        //   return acc + (index > 0 ? '\n' : '') + error;
        // }, '');
        // console.log(errorMessage)
        dispatch(showToast("Unable to add users"));
        setTimeout(() => dispatch(hideToast()), 3000);
      }
      
      setIsPeopleDataFetched(!isPeopleDataFetched)
      handleCloseModal()
    } catch (error) {
      console.log(error)
      dispatch(showToast("Some error occured while uploading file, please try again later"));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
    //  finally{
    // }
}

  const buttons = [
    {
      label: "Add People",
      theme: "warning",
      onClick: redirect,
    },
    {
      label: "Import People",
      theme: "warning",
      onClick: handleShowModal,
    },
  ];

  return (
    <LayoutContainer title="People">
       <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{"Import People - xlsx"}</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
        <div className="font-14">
          <p>
            Use this facility to upload multiple People in one go. Upload
            template can only be Excel. Download sample
            template by clicking on the 'Download Sample File'.
          </p>
          <p>
            <strong>Mandatory fields: </strong> First Name, Last Name, City, Designation, Email, Mobile, Employee Code, Date of Birth
          </p>
          <p>
            Lets say from an upload file of 200 records, if only 150 are valid
            and 50 have issues, system will accept the valid 150 records and
            show appropriate errors for the 50 ones. You can fix the issues for
            those 50 records and then use the same 'Upload with over-write'
            facility (without removing valid 150 records from the file) to
            upload again. System will over-write the 150 valid records again
            without expecting users to remove them from the upload file.
          </p>
          <p>Note: Upload may take some time if the record size is big.</p>
          <p>
            <strong>Sample Upload Time:</strong>
          </p>
          <ul className="list-unstyled">
            <li>100 Records:</li>
            <li>500 Records:</li>
            <li>1000 Records:</li>
          </ul>

          <form onSubmit={handleFileUpload}>

          <div className="mb-4">
            <input type="file" name="peopleExcelFile" accept=".xlsx, .xls"  id="peopleExcelFile" onChange={handleFileChange}/>
          </div>

          <div className="mb-2">
            <CustomButton theme="yellow" type="button" size="md" onClick={handleDownload}>
              <span className="d-flex align-items-center justify-content-center gap-2">
                Download Sample File <FaDownload />
              </span>
            </CustomButton>
          </div>
          <div>
            <CustomButton theme="yellow" type="submit" size="md">
              Upload With Overwrite
            </CustomButton>
          </div>
          </form>
        </div>
        </Modal.Body>
        </Modal>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          People
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div className="mx-2">
      <div className="people-actions">

      </div>
        <PeopleTable isPeopleDataFetched={isPeopleDataFetched} />
      </div>
    </LayoutContainer>
  );
};

export default People;
